import { IDENTIFICATION, PRE_CANCELLED_STATUS } from 'constants/statusProcess';
import { ERROR_CODES } from 'constants/video/videoselfie';
import { COMPLETED, ERROR, PROGRAMMED } from 'constants/video/status';

const getErrorCodeFromStatusResponse = ({ ok, data }) => {
    if (!ok || !data) return ERROR_CODES.GENERIC_NETWORK_ERROR;
    if (data.status === PROGRAMMED) return ERROR;
    if (data.status !== COMPLETED) return data.status;

    return null;
};

export const getErrorFromStatusResponse = ({ ok, data }) => {
    if (data?.onboardingStatus === PRE_CANCELLED_STATUS) return null;
    const errorCode = getErrorCodeFromStatusResponse({ ok, data });
    if (errorCode) return { errorCode, onboardingStatus: IDENTIFICATION };

    return null;
};
